import { render } from "./Toasts.vue?vue&type=template&id=35481f5e&scoped=true&bindings={\"toasts\":\"options\",\"toastClass\":\"options\",\"toastIcon\":\"options\"}"
import script from "./Toasts.vue?vue&type=script&lang=js"
export * from "./Toasts.vue?vue&type=script&lang=js"

import "./Toasts.vue?vue&type=style&index=0&id=35481f5e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35481f5e"

export default script